import { ReferenceAdapter } from '@magicdoorinc/file';
import { fileService } from '~/utils/file';
import { BaseRestRepository } from './baseRestRepository';

export class FileRepository extends BaseRestRepository {
  public async fetchFileResponse(url: string): Promise<Response> {
    const fileUrl = URL.canParse(url) ? url : (await fileService.buildFileUrl(new ReferenceAdapter({ reference: url })))?.url;
    if (!fileUrl) {
      throw new Error('fetchFileResponse: missing reference on source');
    }
    return this.fetchWithAuth(fileUrl, { method: 'GET' });
  }
}

export const fileRepository = new FileRepository();
